import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useTaskClosing } from '../../reducers.js';
import TaskClosingBody from './taskClosingBody';
import Sign from './sign';
import SignContext from './signContext';

import '../../styles/pages/tasks/taskClosing.scss';

const TaskClosingScreen = () => {
	return (
		<SignContext.Provider value={useTaskClosing()}>
			<Routes>
				<Route path="close" element={<TaskClosingBody />} />
				<Route path="sign" element={<Sign />} />
			</Routes>
		</SignContext.Provider>
	);
};

export default TaskClosingScreen;
